export enum UserRole {
    "None" = 0,
    "Admin" = 1,
    "Orders" = 2,
    "Offers" = 3,
    "Finance" = 4,
}